import * as React from "react";
import { forwardRef } from "react";
const SvgArrowUpward = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3.33337 10L4.50837 11.175L9.16671 6.52501V16.6667H10.8334V6.52501L15.4834 11.1833L16.6667 10L10 3.33334L3.33337 10Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgArrowUpward);
export default ForwardRef;
